// extracted by mini-css-extract-plugin
module.exports = {"legends":"Legend_legends__2FffI","legend":"Legend_legend__2y110"};